module.exports = __webpack_public_path__ + "img/stock_saleoff.8f19f27d.png";